import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { SubscribedNotification } from 'src/core/types/subscription.types';

@Injectable({
    providedIn: 'root',
})
export class SubscriptionService {

    constructor(private http: HttpClient) { }

    testdata = [
        {
            id: "asdasd",
            type: "warning",
            title: "Test 1",
            message: "Test message 1",
            timestamp: "2023-10-01T12:00:00Z",
            read: false
        },
        {
            id: "asdasd2",
            type: "warning",
            title: "Test 2",
            message: "Test message 2",
            timestamp: "2023-10-01T12:00:00Z",
            read: false
        }
    ];

    $notifications: BehaviorSubject<SubscribedNotification[]> = new BehaviorSubject<SubscribedNotification[]>([]);
    $notificationsCenter: BehaviorSubject<SubscribedNotification[]> = new BehaviorSubject<SubscribedNotification[]>([]);
    $openNotifications: Subject<void> = new Subject<void>();
    $closeNotifications: Subject<void> = new Subject<void>();

    private stripOwnership<T>(body: T): T {
        if (body && typeof body === 'object') {
            const { mail, accountId, ...rest } = body as Record<string, unknown>;
            return rest as T;
        }

        return body;
    }

    getAllSubscriptions(mail: string) {
        return this.http.get(window.location.protocol + "//" + window.location.hostname + (window.location.port !== "" ? ":" + "8080" : "") + "/data/getAllSubscriptions");
    }

    getSingleSubscription(subscription: any) {
        return this.http.put(window.location.protocol + "//" + window.location.hostname + (window.location.port !== "" ? ":" + "8080" : "") + "/data/getSingleSubscription", this.stripOwnership(subscription));
    }

    activateSubscriptionInBackend(subscription: any) {
        return this.http.put(window.location.protocol + "//" + window.location.hostname + (window.location.port !== "" ? ":" + "8080" : "") + "/data/activateSubscriptionInBackend", this.stripOwnership(subscription));
    }

    deleteSubscriptionInBackend(subscription: any) {
        return this.http.put(window.location.protocol + "//" + window.location.hostname + (window.location.port !== "" ? ":" + "8080" : "") + "/data/deleteSubscriptionInBackend", this.stripOwnership(subscription));
    }

    triggerAzureFunction() {
        return this.http.get(window.location.protocol + "//" + window.location.hostname + (window.location.port !== "" ? ":" + "8080" : "") + "/data/triggerAzureFunction");
    }
}